exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".disabled-input[data-v-35e213a2]{color:#818a91!important}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35e213a2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./static/js/Order/components/EditPrivate.vue
// module id = 758
// module chunks = 0